
                import "css-modules://src_components_html"
                export default {"Body":"_d20365","IsFixed":"_86ee1f","Stage":"_b289a4"}
            